// backend ip when in development mode
let ip = `${window.location.hostname}:1236`;

// backend ip when in production mode
if (process.env.NODE_ENV === 'production') {
  //20211115 modified: remove port 1236 to solve cros problem
  ip = `${window.location.hostname}`; //測試用
}

// server with "http" prefix
const server = `https://${ip}`;
export default server;
// baceknd websocket server used in Admin components
//20211115 modified
export const webSocketServer = `wss://${window.location.hostname}:1235`;


// local websocket server for connecting peripherial devices (ex: cabinet firmware, fingerprinter)
const taskServer = 'localhost:8888';
export const TaskWebSocketServer = `ws://${taskServer}/socket`;
export const commandSocketServer = `http://${taskServer}/`;

// other settings
export const version = '01.01';  // version: release, django, task-server, vue
export const systemType = 'ADC'; // ADC, Tag



// WEBPACK FOOTER //
// ./src/config.js